import axios from "axios";

const getCompanyIndustryEnums = () => {
  return axios.get("enums/company/industry");
};

const getCompanySizeEnums = () => {
  return axios.get("enums/company/size");
};

const getCompanyInvoiceFrequencyEnums = () => {
  return axios.get("enums/company/invoice-frequency");
};

const getCompanyNotificationModeEnums = () => {
  return axios.get("enums/company/notification-mode");
};

const getCompanyPortfolioStatusEnums = () => {
  return axios.get("enums/company/portfolio-status");
};

const getCompanyTypeEnums = () => {
  return axios.get("enums/company/type");
};

const getCountriesFormsRequiredEnums = () => {
  return axios.get("enums/patent-office/countries-that-require-form");
};

export {
  getCompanyIndustryEnums,
  getCompanySizeEnums,
  getCompanyInvoiceFrequencyEnums,
  getCompanyNotificationModeEnums,
  getCompanyPortfolioStatusEnums,
  getCompanyTypeEnums,
  getCountriesFormsRequiredEnums,
};
